import { useContext } from 'react';
import { RequestContext } from './request-provider';

export default () => useContext(RequestContext);
